<template>
  <div class="info-text application-heading">
    What are verified events?
    <v-btn :href="url" target="_blank" icon class="btn-icon">
      <v-icon small>fas fa-info-circle</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "SearchVerifiedInfo",
  data: function () {
    return {
      url:
        "https://geosparkio.atlassian.net/wiki/spaces/BGS/pages/2954919937/Verified+Events",
    };
  },
};
</script>

<style scoped>
.info-text {
  font-size: 12px;
  text-align: center;
}
.btn-icon {
  position: relative;
  top: -1px;
}
</style>
